import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DirectionProvider, RouteLoader } from "@envirohub/ui";
import { DocumentMeta } from "@/components/DocumentMeta";
import { PrivateRoute } from "@/components/PrivateRoute";

const PublicLayout = lazy(() => import("./layouts/PublicLayout"));
const AdminLayout = lazy(() => import("./layouts/AdminLayout"));
const LoginPage = lazy(() => import("./pages/LoginPage"));
const ForgotPassword = lazy(() => import("./pages/ForgotPasswordPage"));
const ChangePasswordPage = lazy(() => import("./pages/ChangePasswordPage"));

export default function App() {
  const { i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <DirectionProvider dir={dir}>
      <BrowserRouter>
        <DocumentMeta />
        <Suspense fallback={<RouteLoader fullScreen />}>
          <Routes>
            <Route
              element={
                <Suspense fallback={<RouteLoader fullScreen />}>
                  <PublicLayout />
                </Suspense>
              }
            >
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/change-password"
                element={
                  <PrivateRoute>
                    <ChangePasswordPage />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route
              path="/*"
              element={
                <PrivateRoute>
                  <AdminLayout />
                </PrivateRoute>
              }
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </DirectionProvider>
  );
}
